import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const QuestionnaireStatisticWrapper = styled.div`
    display: grid;
    grid-template-columns: 40px 1fr;
    gap: 16px;
`;

// HEADER
export const QuestionnaireStatisticHeader = styled.div`
    align-items: baseline;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
`;

// CONTENT
export const QuestionnaireStatisticContent = styled.div`
    align-items: center;
    display: flex;
    gap: 0 16px;
`;

export const QuestionnaireStatisticInfo = styled(Typography.TextBody_14_20)(
    ({ theme: { fontWeight, palette } }) => css`
        color: ${palette.text.assistive};
        flex-shrink: 0;
        font-weight: ${fontWeight.normal};
        text-align: right;
        white-space: nowrap;
        width: 100px;
    `,
);

export const LinkWrapper = styled.div`
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    width: 100px;
`;

export const QuestionnaireStatisticsIcon = styled.div<{
    backgroundColor: string;
}>(
    ({ backgroundColor, theme: { radius } }) => css`
        align-items: center;
        background: ${backgroundColor};
        border-radius: ${radius['8']}px;
        display: flex;
        height: 40px;
        justify-content: center;
        width: 40px;
    `,
);
